import styled from 'styled-components';
import Button from '@app/ui/Button/Button';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import Title from '@app/ui/Typography/Title';
import Body from '@app/ui/Typography/Body';
import image from './error.png';
import { useIsMobile } from '@app/contexts/viewport';

const Fullscreen = styled.div`
  position: absolute;
  inset: 0;
  background: ${({ theme }) => theme.colors.white};
  z-index: 10000;
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  place-content: center center;
  gap: ${({ theme }) => theme.space.xxl};
  flex-wrap: wrap-reverse;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 ${({ theme }) => theme.space.xxxxl};

  @media (width <= 1024px) {
    gap: ${({ theme }) => theme.space.l};
    padding: 0 ${({ theme }) => theme.space.l};
  }
`;

const MessageWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  max-width: 500px;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.l};
`;

const Image = styled.img`
  max-width: min(500px, 100%);
`;

export type FallbackProps = {
  title: string;
  body: React.ReactNode;
  button?: string;
  onClick?: React.ComponentProps<typeof Button>['onClick'];
  fullscreen?: boolean;
};

const FallbackContent = ({ title, body, button, onClick }: FallbackProps) => {
  const isMobile = useIsMobile();
  return (
    <Wrapper>
      <MessageWrapper>
        <Title
          mt="md"
          type={
            isMobile ? ThemeFontStyleTypeEnum.headingLarge : ThemeFontStyleTypeEnum.headingLarge
          }
        >
          {title}
        </Title>
        <Body mb="md" type={ThemeFontStyleTypeEnum.bodyMedium}>
          {body}
        </Body>
        {button && (
          <Button
            onClick={onClick}
            style={{ width: '100%' }}
            type="primary"
            size={isMobile ? 'small' : 'medium'}
          >
            {button}
          </Button>
        )}
      </MessageWrapper>
      <Image src={image} />
    </Wrapper>
  );
};

const Fallback: typeof FallbackContent = ({ fullscreen, ...props }) => {
  if (fullscreen) {
    return (
      <Fullscreen>
        <FallbackContent {...props} />
      </Fullscreen>
    );
  }

  return <FallbackContent {...props} />;
};

export default Fallback;
